export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_server-control-panel-14/artifacts/mrn70swp_ChatGPT%20Image%20Aug%2015%2C%202026%2C%2010_53_11%20PM%20%281%29.png";
export const BANNER_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_server-control-panel-14/artifacts/21e49e054d4d544a_image.png";

export const Brand = ({ size = "md", sub, onClick }) => {
  const s = size === "lg" ? { img: "w-14 h-14", text: "text-4xl" } : size === "sm" ? { img: "w-7 h-7", text: "text-lg" } : { img: "w-9 h-9", text: "text-2xl" };
  return (
    <div className={`flex items-center gap-3 ${onClick ? "cursor-pointer" : ""}`} onClick={onClick} data-testid="brand">
      <img src={LOGO_URL} alt="ModNode" className={`${s.img} drop-shadow-[0_0_14px_rgba(139,92,246,0.55)]`} data-testid="brand-logo" />
      <div className="leading-none">
        <div className={`mm-chrome ${s.text} uppercase`}>ModNode</div>
        {sub && <div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-[#64748B]">{sub}</div>}
      </div>
    </div>
  );
};
